exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".load-bg[data-v-801560ba]{position:fixed;top:0;bottom:0;left:0;right:0;background-color:#fff;text-align:center;overflow-y:scroll;z-index:1050;margin-right:-18px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-801560ba","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layout/Load.vue
// module id = 294
// module chunks = 0